/**
 * mb nav菜单图标
 */
const HambergerIcon = ({ width = 24, height = 24, color = '#ffffff' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect x="2" y="4" width="20" height="2" fill={color} />
      <rect x="2" y="11" width="20" height="2" fill={color} />
      <rect x="2" y="18" width="20" height="2" fill={color} />
    </svg>
  )
}

export default HambergerIcon
